export default "__VITE_ASSET__BbmkpU2t__"